<style lang="less">
.home {
  width: 100%;
  height: 100vh;
  background-color: #f0f2f6;
  .popups {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.7);
    .main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 80%;
      height: 80%;
      border-radius: 20px;
      background-color: #fff;
      padding: 40px;
      box-sizing: border-box;
      .title {
        width: 100%;
        line-height: 100px;
        text-align: center;
        font-size: 36px;
        font-family: "PingFangSC-Semibold", "PingFang SC Semibold",
          "PingFang SC", sans-serif;
        font-weight: 650;
        font-style: normal;
      }
      .content {
        width: 100%;
        font-family: "ArialMT", "Arial", sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 22px;
        letter-spacing: normal;
        color: #333333;
        height: 85%;
        overflow-y: auto;
        text-align: left;
      }
      .bottom {
        position: absolute;
        left: 0px;
        bottom: 0px;
        height: 80px;
        width: 100%;
        border-top: 1px solid rgba(215, 215, 215, 1);
        .no {
          float: left;
          width: 50%;
          height: 100%;
          line-height: 80px;
          text-align: center;
          font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
          font-weight: 400;
          font-style: normal;
          color: #aaaaaa;
          font-size: 22px;
          border-right: 1px solid rgba(215, 215, 215, 1);
          box-sizing: border-box;
        }
        .off {
          float: left;
          width: 50%;
          height: 100%;
          line-height: 80px;
          text-align: center;
          font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
          font-weight: 400;
          font-style: normal;
          color: #d9001b;
          font-size: 22px;
          border-radius: none;
        }
        button::after {
          border: none;
        }
      }
    }
  }
  .zongguo {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .home-banner {
      padding: 10px;
      height: 339px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header {
      width: 100%;
      height: 264px;
      padding: 30px;
      box-sizing: border-box;
      background-color: #fff;
      .text {
        width: 100%;
        font-size: 32px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        span {
          display: inline-block;
          width: 6px;
          height: 29px;
          background: rgba(0, 169, 255, 1);
          border-radius: 3px;
          vertical-align: middle;
        }
      }
      .banners {
        margin-top: 28px;
        width: 100%;
        height: 85px;
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAmQAAABQCAMAAACAu5kcAAACcFBMVEVHcEw5xv86yvs6y/o6zPs6y/w6y/s6y/s6y/s6y/w7y/s6yvo6y/s6y/s5y/o6zPw6y/s6yvo6y/s7zPs3yP87y/w5y/s7zv9AzP86y/w6y/w6y/s6y/s6y/s6zPs7y/s5y/w6y/s5y/w8yfo5y/w6y/s5y/o5yvs6y/s6y/s6y/s6y/s5zPk5yvo5y/s7zPs6y/o5y/w5zPs6y/s6zPg7y/o6y/s7y/s7yvk1yv89yPk9zv87y/o6y/s7y/s3yP86y/w7zfo6y/s5zPk6y/o8zPs6y/s6y/s6zPw6yvs6y/s6y/s5zPw6y/s6zPs7y/s6y/w6y/s5zPw6zPs5y/s5zPs6y/s6y/s7y/s5yvs7y/w6yvo7yvw6yvs7yvw7yvs6zv87y/o4y/s5y/s6zPo6y/s6y/s5zfg3yPg6y/s+yfc6yvs6zPs5y/s5zPs6y/szzP85yvs7yfok2/85zPs6y/s5yvo6y/s7y/o6y/s6y/w8zP88zfo7yvs6y/s8y/g6y/s6y/s5yvs7yvo7yvw6yvo7y/s6y/s6y/s5zfs6y/s6y/s7zPs6y/s4x/c6y/w7y/w8yfg6y/s5y/o6y/s5y/o6y/s6yvw4zPo80v86y/s+yv86y/s6y/o6y/o7y/s7y/s6y/s6yvw60f88yvw6zPw7yvw6yvs6y/w6y/k6y/s6yvs5yvs7zfs5zfw6zPo5yfw6y/s6yvo6y/o4zfk3zfk6y/s6zPo6y/s6zPs5zPw5xv84y/s5y/s9zP87yvs6y/s7y/w7yvs6yvs6y/s5y/o6y/s5zPs6zPs6zPo5zPo6y/s6yfs6y/o7y/g6y/tJQPcgAAAAz3RSTlMAEj7hkJLG/faexGD662ff5mWNQReU9BoU3du5/vvku5ftXi+c+TZD/Nl77ihvyIuoWYbjI2zotysYKhVj6kUcmTjzLaM88LRLwvGIUMvQqlSsVXOy1fXW0XRJMFa9W3kfoTutacyEJCWJIYN3v33ADzo0B4HKoNRxz08eM37SIq+wSKVXanXX00fN7K6+IFNOJvJw9zF/XDIR2B3Ooqd654CbFk2aUrNdLHb3iz1MblHBNaYpLu9tsdpaG0S2GYKrSofp+GK1eEakqck54iev+1qUAAACEklEQVR42u3SBzvUcQDAcfvucMdxHA7n7O3svbnjGhraUSFURkMqKiJtiopKe++9l/Yeb6nfX/J4egMez/P9vIaPlRUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATB3WG9Yet/bK1LzWvhhevjqp/ld0xrVHS46tD82vumXjHpazd3HJoekH5+yMHwp0ylKrapLvHJ6763Nk02BL7btVcW529h4BeecVrae+nv42+8COK59SdfqKxnuODrEbV56cuX3TghPPfLxdbH/6u6ZkK/dHmSwFnvPl8hBnP5nM9zcmg294uJ/zhyNyzwKLKcqgfH/W1T/R1sXbJ2L3vD0Lt+yb8d3BsbS5V69LNT/trH5jfFC0QhF8KcDD3s4tblrCmpZtkcsaFm2OSa5RqbOcAivjl8663Hb7bVdOmLtN8br8+1uPBhWmZUT313X0Dedq0zWZXuPJLmjStbntIlld/8O0wiAp2Y+q4onJng9dlZL1PIkRyRrONA2O1Cb8SxasaC3qNpaJZOVmkay3uXRCsggpWeJYsseWAZHsBskmM5lMJAuRkg2YDAZldsp/yWJFssYKve6VubyzuszYLSXLG012UyQ7J5Jdl5L1qNQf/ya723axpOvLy9FkoWPJ6pM6+trHkwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA1PEH8ojupkBHm3wAAAAASUVORK5CYII=");
        background-size: 100% 100%;
        display: flex;
        div {
          flex: 1;
          height: 100%;
          text-align: center;
          img {
            width: 85px;
            height: 79px;
          }
        }
      }
      .names {
        width: 100%;
        display: flex;
        margin-top: 10px;
        font-size: 28px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        div {
          flex: 1;
          text-align: center;
        }
      }
    }
    .floor {
      margin-top: 31px;
      width: 100%;
      height: 387px;
      padding: 30px;
      box-sizing: border-box;
      background-color: #fff;
      .text {
        width: 100%;
        font-size: 32px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        span {
          display: inline-block;
          width: 6px;
          height: 29px;
          background: rgba(0, 169, 255, 1);
          border-radius: 3px;
          vertical-align: middle;
        }
      }
      .main {
        width: 100%;
        margin-top: 40px;
        overflow: hidden;
        .mainleft {
          float: left;
          width: 291px;
          margin-top: 25px;
          padding-left: 7px;
          img {
            width: 100%;
            height: 192px;
          }
        }
        .mainright {
          float: right;
          padding-right: 9px;
          text-align: left;
          .item {
            width: 100%;
            line-height: 62px;
            font-size: 26px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            span {
              display: inline-block;
              width: 26px;
              height: 26px;
              line-height: 26px;
              text-align: center;
              background: rgba(53, 221, 252, 1);
              border-radius: 50%;
              color: #fff;
              margin-right: 7px;
              font-size: 20px;
              font-family: MicrosoftYaHei;
              font-weight: 400;
            }
          }
        }
      }
    }
    .buttom {
      width: 686px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      margin: 0 auto;
      margin-top: 35px;
      background: rgba(29, 168, 255, 1);
      border-radius: 10px;
      font-size: 36px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .floot {
      width: 100%;
      height: 10%;
    }
  }
}
</style>
<template>
  <div class="home">
    <div class="zongguo">
      <div class="home-banner">
        <img
          src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_2451161449434710320212814397103banner.png"
          alt
        />
      </div>
      <div class="header">
        <div class="text"><span></span> 认证流程</div>
        <div class="banners">
          <div v-for="(o, i) in headerImgArr" :key="i">
            <img :src="o.icon" alt />
          </div>
        </div>
        <div class="names">
          <div v-for="(o, i) in headerImgArr" :key="i">{{ o.name }}</div>
        </div>
      </div>
      <div class="floor">
        <div class="text"><span></span> 你需要准备的材料</div>
        <div class="main">
          <div class="mainleft">
            <img
              src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_495515919272649802020121014980z2.png"
              alt
            />
          </div>
          <div class="mainright">
            <div class="item"><span>1</span>身份证正反面</div>
            <div class="item"><span>2</span>本人实名制的联系电话</div>
            <!-- <div class="item">
              <span>3</span>提供公司名称
            </div> -->
            <div class="item"><span>3</span>银行卡</div>
          </div>
        </div>
      </div>
      <div class="buttom" @click="enroll">实名认证</div>
      <div class="floot"></div>
    </div>
    <div class="popups" v-if="popupsType" :animation="dropDown">
      <div class="main">
        <div class="title">个体宝隐私政策</div>
        <div class="content"><privacyPolicy></privacyPolicy></div>
        <div class="bottom">
          <div class="no" @click="butongyi">不同意</div>
          <div class="off" @click="onGotUserInfo">同意并继续</div>
        </div>
      </div>
    </div>
    <!-- <div id="modal" v-if="tankuang">
      <div class="fangkuai">
        <div class="weideng">您还未登录</div>
        <div class="jinxin">请先登录在进行操作</div>
        <div class="tupian">
          <img src="/static/images/huojian.png" alt style="width:100px;height:100px;" />
        </div>
        <div class="juzhong">
          <div>
            <button class="baoguo" @click="tankuang=false">暂不登录</button>
          </div>
          <div>&nbsp;&nbsp;</div>
          <div>
            <button
              class="button1"
              open-type="getUserInfo"
              lang="zh_CN"
              @getuserinfo="onGotUserInfo"
            >立即登录</button>
          </div>
        </div>
      </div>
    </div> -->
    <tabbar></tabbar>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";
import privacyPolicy from "@/components/privacyPolicy";
import tabbar from "@/components/tabbar";

export default {
  data() {
    return {
      marginTop: null,
      popupsType: false,
      dropDown: {},
      tankuang: false,
      userInfo: {
        nickName: "mpvue",
        avatarUrl: "http://mpvue.com/assets/logo.png",
      },
      headerImgArr: [
        { icon: "/static/images/icon1.png", name: "身份证上传" },
        { icon: "/static/images/icon2.png", name: "银行卡上传" },
        { icon: "/static/images/icon3.png", name: "完成认证" },
      ],
    };
  },
  components: {
    privacyPolicy: privacyPolicy,
    tabbar: tabbar,
  },
  mounted() {
    var that = this;
    // http.post(config.uploadConfig, {}).then(d => {
    //   if (d.code == 1) {
    //     console.log(d);
    //     var data = d.data;
    //     var obj = {
    //       d: {},
    //       action: ""
    //     };
    //     obj.d["key"] = "key";
    //     obj.d["Bucket"] = data.Bucket;
    //     obj.d["OSSAccessKeyId"] = data.OSSAccessKeyId;
    //     obj.d["signature"] = data.Signature;
    //     obj.d["policy"] = data.policy;
    //     obj.d["success_action_status"] = data.success_action_status;
    //     obj.action = data.url;
    //     sessionStorage.setItem("data",obj);
    //   }
    // });
  },
  onShow() {
    this.popupsType = false;
  },
  methods: {
    butongyi() {
      // var animation = wx.createAnimation({
      //     duration: 50,
      // })
      // animation.opacity(0).step();
      // animation.bottom('-999px').step();
      // this.dropDown = animation.export();
      this.popupsType = false;
    },
    enroll() {
      if (sessionStorage.getItem("esignappsid")) {
        const url = "/legalPerson";
        this.$router.push({ path: url });
        // wx.hideTabBar({
        //   animation:false
        // })
      } else {
        let url = "/login";
        this.$router.push({ path: url });
      }
    },
    clickHandle(ev) {
      console.log("clickHandle:", ev);
      // throw {message: 'custom test'}
    },
    onGotUserInfo() {
      this.popupsType = false;
      const url = "/legalPerson";
      this.$router.push({ path: url });

      // var that = this
      // wx.login({
      //     success (res) {
      //         console.log(e)
      //         console.log(res)
      //         if (res.code) {
      //             http.post(config.login,{
      //                 iv: e.mp.detail.iv,
      //                 encryptedData: e.mp.detail.encryptedData,
      //                 code: res.code,
      //                 merchant_id: "11247613260000707",
      //                 avatarUrl: e.mp.detail.userInfo.avatarUrl,
      //                 nickName: e.mp.detail.userInfo.nickName
      //             }).then( (e) => {
      //                 if (e.code == 1) {
      //                     sessionStorage.setItem({
      //                         key:"openId",
      //                         data:e.data.openid
      //                     })
      //                     wx.showToast({
      //                         title: '登录成功',
      //                         icon: 'success',
      //                         duration: 2000
      //                     })
      //                   //  that.tankuang = false;
      //                 }
      //             })
      //         } else {
      //         console.log('登录失败！' + res.errMsg)
      //         }
      //     }
      // })
    },
  },
  created() {},
};
</script>

<style scoped>
.userinfo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.userinfo-avatar {
  width: 128px;
  height: 128px;
  margin: 20px;
  border-radius: 50%;
}

.userinfo-nickname {
  color: #aaa;
}

.usermotto {
  margin-top: 150px;
}

.form-control {
  display: block;
  padding: 0 12px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
}
.all {
  width: 7.5rem;
  height: 1rem;
  background-color: blue;
}
.all:after {
  display: block;
  content: "";
  clear: both;
}
.left {
  float: left;
  width: 3rem;
  height: 1rem;
  background-color: red;
}

.right {
  float: left;
  width: 4.5rem;
  height: 1rem;
  background-color: green;
}

#modal {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 90;
  background-color: rgba(0, 0, 0, 0.6);
}
#modal .fangkuai {
  width: 550px;
  height: 600px;
  border: 2px solid #fff;
  margin: 0 auto;
  margin-top: 200px;
  background: #fff;
  border-radius: 25px;
}
#modal .juzhong {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
#modal .tupian {
  margin: 0 auto;
  width: 100px;
  margin-top: 60px;
}
#modal .weideng {
  text-align: center;
  margin-top: 70px;
  font-weight: 600;
  font-size: 38px;
}
#modal .jinxin {
  text-align: center;
  margin-top: 30px;
  font-size: 30px;
  color: #666;
}
#modal .baoguo {
  width: 230px;
  height: 80px;
  margin: 0 auto;

  line-height: 80px;
  color: #6badff;
  text-align: center;
  background: #fff;
  border-radius: 40px;
  border: 1px solid #6badff;
  font-size: 33px;
}
#modal .button1 {
  width: 230px;
  height: 80px;
  margin: 0 auto;

  line-height: 80px;
  color: #fff;
  text-align: center;
  background: #6badff;
  border-radius: 40px;
  border: 1px solid #6badff;
  font-size: 33px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue